import React from "react";
import "../../../styles/loaders/apex-chart-loader.css";

const ApexChartLoader = ({ height = "300px" }) => {
  return (
    <div className="chart-skeleton-loader" style={{ height: height }}>
      <div className="chart-skeleton-title"></div>
      <div className="chart-skeleton-content">
        <div className="chart-skeleton-yaxis">
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
        </div>
        <div className="chart-skeleton-main">
          <div className="skeleton-wave"></div>
          <div className="chart-skeleton-xaxis">
            <div className="skeleton-label"></div>
            <div className="skeleton-label"></div>
            <div className="skeleton-label"></div>
            <div className="skeleton-label"></div>
          </div>
        </div>
      </div>
      <div className="chart-skeleton-legend">
        <div className="skeleton-legend-item"></div>
      </div>
    </div>
  );
};

export default ApexChartLoader;
